import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";
import styles from "./StatementsOfWork.scss";

import { Mixpanel } from "../../../../../actions/mixpanel.actions";
import { PROJECT_SOW_TABLE } from "../../../../../actions/project.actions";

class StatementsOfWork extends React.Component {
  render() {
    const mappedMatches = this.props.acceptedPitches.map(acceptedPitch => {
      const project = _.get(acceptedPitch, "match.project");

      return {
        rowKey: project.id,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: this.getProjectStatusText(acceptedPitch),
            orderByText: this.getProjectStatusText(acceptedPitch)
          },
          {
            displayText: acceptedPitch.updated_at
              ? formatDateSmall(acceptedPitch.updated_at)
              : "No SOW yet",
            orderByText: acceptedPitch.updated_at || ""
          },
          {
            displayText: this.getButtonsDisplayText(project, acceptedPitch)
          }
        ]
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "PROJECT",
          id: "table-member-sows-sort-project",
          track: "Table - Member SOWs - Sort By Project"
        },
        {
          displayText: "STATUS",
          id: "table-member-sows-sort-status",
          track: "Table - Member SOWs - Sort By Status"
        },
        {
          displayText: "DATE SELECTED",
          id: "table-member-sows-sort-date-selected",
          track: "Table - Member SOWs - Sort By Date Selected"
        },
        {
          displayText: "",
          sortDisable: true
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 2,
      order: "asc"
    };

    return (
      <div className={styles.statements}>
        <h2 className={styles.pageTitle}>Statements Of Work</h2>
        <p className={styles.pageSubTitle}>
          Here you’ll find the projects that you’ve pitched and been selected by
          the Company to do. When you’ve completed a project, be sure to click
          “Complete Project” so we can invoice the client and you can provide
          feedback.
        </p>
        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={PROJECT_SOW_TABLE}
          colsConfig={["45%", "20%", "20%", "15%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link
            to={`/member/company/${company.id}`}
            onClick={() =>
              Mixpanel.track("Member - SOWs - Project Company Name")
            }
          >
            {company.name}
          </Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link
            to={`/member/project/${project.id}/detail`}
            onClick={() => Mixpanel.track("Member - SOWs - Project Job Title")}
          >
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getProjectStatusText(pitch) {
    const statusText = {
      sow: "SOW",
      "in-progress": "In Progress"
    };

    return statusText[this.props.getProjectStatusOfPitch(pitch)];
  }

  getButtonsDisplayText(project, pitch) {
    const sow = (
      <Link
        to={`/member/project/${project.id}/sow`}
        className={styles.blueButton}
        onClick={() => Mixpanel.track("Member - SOWs - Submit SOW")}
      >
        {pitch.sow && pitch.sow.edits_requested ? "Edit SOW" : "Submit SOW"}
      </Link>
    );

    const complete = (
      <Link
        to={`/member/project/${project.id}/sow`}
        className={styles.blueButton}
        onClick={() => Mixpanel.track("Member - SOWs - View SOW")}
      >
        View SOW
      </Link>
    );

    const buttons = {
      sow: sow,
      "in-progress": complete
    };

    return (
      <div className={styles.actionsContainer}>
        {buttons[this.props.getProjectStatusOfPitch(pitch)]}

        <Link
          to={`/member/project/${project.id}/detail`}
          onClick={() => Mixpanel.track("Member - SOWs - Project Arrow")}
        >
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );
  }
}

export default StatementsOfWork;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/statementsOfWork/components/StatementsOfWork.js